import React, { ReactNode } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import TopNav from '../Components/TopNav';
import SideNav from '../Components/SideNav';
import ValuationStatusBanner from '../Components/Forms/ValuationStatusBanner';

interface Props {
	children: ReactNode;
	pageTitle?: string;
}

const AuthedLayout = (props: Props) => {
	const location = new URL(window.location.href).pathname.split('/');
	const valuationId =
		(location[1] == 'valuation-form' && parseInt(location[2]))
			? parseInt(location[2])
			: null;
	const showSidebar = true;

	return (
		<Container fluid className='authed-layout'>
			<Row>
				{showSidebar && (
					<Col
						md={2}
						className='sidebar-col bg-primary d-none d-md-flex'
					>
						{valuationId && (
							<div className='side-nav-scroll'>
								<SideNav valuationId={valuationId} pageName={location[3]} pageIndex={location[4]} />
							</div>
						)}
					</Col>
				)}
				<Col md={showSidebar ? 10 : 12} className='main-col px-0'>
					<div className="sticky-header bg-white border-bottom border-ltGrey">
						<div className="px-5">
							<TopNav />
						</div>
						{valuationId && (
							<div className='px-5 mt-4 pb-3'>
								<ValuationStatusBanner />
							</div>
						)}
					</div>
					{props.pageTitle && (
						<div className='px-5 py-4 border-bottom border-ltGrey'>
							<h5 className='mb-0 fw-bold'>{props.pageTitle}</h5>
						</div>
					)}
					<div className='mt-8 body-container'>
						<Container fluid className='px-5'>
							{props.children}
						</Container>
						{/* footer */}
						<div className='footer mt-10 mb-5 border-top'>
							<p className='copyright text-decoration-none mt-5'>
								© 2026 <a href='#'>IA Valuations.</a> All Rights
								Reserved.
							</p>
						</div>
					</div>
				</Col>
			</Row>
		</Container>
	);
};

export default AuthedLayout;
